// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.NicheCard {
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  padding: 4px;
  background-color: white;
  border-radius: 4px;
  align-items: center;
  border: 1px solid var(--color_neutral_400);
}
.NicheCard .NicheCard-leftSection {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.NicheCard .NicheCard-colorBar {
  height: 54px;
  width: 2px;
  border-radius: 2px;
}
.NicheCard .NicheCard-rightContent {
  margin-left: auto;
  display: flex;
  column-gap: 8px;
  margin-right: 8px;
}
.NicheCard .NicheCard-rightContent svg {
  opacity: 0;
  color: var(--color_neutral_800);
}
.NicheCard .NicheCard-rightContent .NicheCard-shouldAppear svg {
  opacity: 1;
}
.NicheCard .NicheCard-titleSection {
  padding: 6px 0px;
}
.NicheCard .NicheCard-checkboxSection {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
}
.NicheCard .NicheCard-checkboxSection .TerritoryAddToCheckbox {
  margin: 0px;
}
.NicheCard .NicheCard-title {
  color: var(--color_neutral_900);
  font-size: 14px;
  font-weight: 700;
  max-width: 200px;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.NicheCard .NicheCard-subtitle {
  color: var(--color_neutral_800);
  font-size: 12px;
  font-weight: 400;
}
.NicheCard .NicheCard-iconSection {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: flex-end;
}
.NicheCard .NicheCard-iconSection button {
  display: flex;
  align-items: center;
  justify-content: center;
}
.NicheCard .NicheCard-copyQuerySection {
  height: 20px;
  justify-self: flex-end;
}
.NicheCard .NicheCard-copyQuerySection button {
  padding: 0;
  height: 20px;
}
.NicheCard .NicheCard-copyQuerySection button svg {
  color: var(--color_neutral_800);
}
.NicheCard:hover a.NicheCard-title {
  color: var(--color_primary_500);
  text-decoration: underline;
}
.NicheCard:hover .NicheCard-rightContent svg {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/niche/niche-card/niche-card.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;AAeF;AAbE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAeJ;AAZE;EACE,YAAA;EACA,UAAA;EACA,kBAAA;AAcJ;AAXE;EACE,iBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AAaJ;AAXI;EACE,UAAA;EACA,+BAAA;AAaN;AATM;EACE,UAAA;AAWR;AANE;EACE,gBAAA;AAQJ;AALE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAOJ;AALI;EACE,WAAA;AAON;AAHE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ED5DF,oBAAA;EACA,aC4DsB;ED3DtB,qBC2DsB;ED1DtB,4BAAA;EACA,gBAAA;EACA,sBANoC;ACwEtC;AAPE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;AASJ;AANE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAQJ;AANI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAQN;AAJE;EACE,YAAA;EACA,sBAAA;AAMJ;AAJI;EACE,UAAA;EACA,YAAA;AAMN;AAJM;EACE,+BAAA;AAMR;AAAI;EACE,+BAAA;EACA,0BAAA;AAEN;AAEM;EACE,UAAA;AAAR","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.NicheCard {\n  display: flex;\n  flex-direction: row;\n  column-gap: 12px;\n  padding: 4px;\n  background-color: white;\n  border-radius: 4px;\n  align-items: center;\n  border: 1px solid var(--color_neutral_400);\n\n  .NicheCard-leftSection {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .NicheCard-colorBar {\n    height: 54px;\n    width: 2px;\n    border-radius: 2px;\n  }\n\n  .NicheCard-rightContent {\n    margin-left: auto;\n    display: flex;\n    column-gap: 8px;\n    margin-right: 8px;\n\n    svg {\n      opacity: 0;\n      color: var(--color_neutral_800);\n    }\n\n    .NicheCard-shouldAppear {\n      svg {\n        opacity: 1;\n      }\n    }\n  }\n\n  .NicheCard-titleSection {\n    padding: 6px 0px;\n  }\n\n  .NicheCard-checkboxSection {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 12px;\n\n    .TerritoryAddToCheckbox {\n      margin: 0px;\n    }\n  }\n\n  .NicheCard-title {\n    color: var(--color_neutral_900);\n    font-size: 14px;\n    font-weight: 700;\n    max-width: 200px;\n    @include line-clamp(1);\n  }\n\n  .NicheCard-subtitle {\n    color: var(--color_neutral_800);\n    font-size: 12px;\n    font-weight: 400;\n  }\n\n  .NicheCard-iconSection {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    justify-self: flex-end;\n\n    button {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  .NicheCard-copyQuerySection {\n    height: 20px;\n    justify-self: flex-end;\n\n    button {\n      padding: 0;\n      height: 20px;\n\n      svg {\n        color: var(--color_neutral_800);\n      }\n    }\n  }\n\n  &:hover {\n    a.NicheCard-title {\n      color: var(--color_primary_500);\n      text-decoration: underline;\n    }\n\n    .NicheCard-rightContent {\n      svg {\n        opacity: 1;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
